import { Badge, Loader } from '@mantine/core'
import { observer } from 'mobx-react-lite'
import type { ReactNode } from 'react'

import { useGlobalState } from '@/hooks/useGlobalState'

/**
 * The library's gray PROCESSING badge in place of a module's status, for a module the server says is
 * processing or one a bulk upload in this tab is still creating. It observes the store itself, since
 * table cells render outside the screen's observer.
 */
export const ModuleProcessingGate = observer(function ModuleProcessingGate({
  taskId,
  inProcess,
  children,
}: {
  taskId: string
  inProcess: boolean | null | undefined
  children: ReactNode
}) {
  const { bulkUploadStore } = useGlobalState()
  if (!inProcess && !bulkUploadStore.isCreatingModule(taskId)) return <>{children}</>
  return (
    <Badge variant="filled" color="gray" rightSection={<Loader size="xs" color="white" type="dots" />}>
      PROCESSING
    </Badge>
  )
})
